var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberOne = function SvgIconNumberOne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.847 2.118a1 1 0 0 1 .528.882v18a1 1 0 1 1-2 0V4.869L8.43 6.832a1 1 0 0 1-1.11-1.664l4.5-3a1 1 0 0 1 1.027-.05"
  })));
};
export default SvgIconNumberOne;